import { SIGNAL_SCAN_COMPANY_CREDITS } from "@signalist/shared-types";

import { FunctionComponent } from "react";
import { Trans, useTranslation } from "react-i18next";

import { CreditConfirmModal, formatCredits } from "@/components/CreditConfirmModal";

interface RunSignalSearchConfirmModalProps {
	/** Companies the search would scan. */
	count: number;
	onClose: () => void;
	/** Starts the scans; rejects when the API refuses them, which the dialog then shows. */
	onConfirm: () => Promise<unknown>;
}

/**
 * The confirmation every "Run signal search" goes through, for one company or a selection
 * (PREC-3240), on the credit-confirm modal (PREC-4263): the companies it scans, at the price the
 * API charges per company, the balance after, and a top-up when the balance cannot pay.
 */
export const RunSignalSearchConfirmModal: FunctionComponent<RunSignalSearchConfirmModalProps> = ({
	count,
	onClose,
	onConfirm,
}) => {
	const { t } = useTranslation();

	return (
		<CreditConfirmModal
			isOpened
			body={
				<Trans
					components={{ b: <b className="font-semibold" /> }}
					i18nKey="creditConfirm.signalScan.body"
					values={{ count }}
				/>
			}
			confirmLabel={t("creditConfirm.signalScan.confirm", { count })}
			segments={[
				{
					id: "COMPANIES",
					label: t("creditConfirm.signalScan.COMPANIES", {
						count,
						unit: formatCredits(SIGNAL_SCAN_COMPANY_CREDITS),
					}),
					count,
					unitCredits: SIGNAL_SCAN_COMPANY_CREDITS,
					included: true,
				},
			]}
			title={t("profileTracker.runSignalSearch.title")}
			onClose={onClose}
			onConfirm={onConfirm}
		/>
	);
};
